import Home from "../home/Home";
import FormsList from "../forms/FormsList";
import FormsDesigner from "../forms/FormsDesigner";
import FormsEditor from "../forms/FormsEditor";
import NpsDesigner from "../nps/NpsDesigner";
import NpsList from "../nps/NpsList";
import NpsEditor from "../nps/NpsEditor";
export var APP_ROUTES = {
    "/": Home,
    "/forms": FormsDesigner,
    "/forms/list": FormsList,
    "/forms/edit/:slug": FormsEditor,
    "/nps": NpsDesigner,
    "/nps/list": NpsList,
    "/nps/edit/:slug": NpsEditor,
};
